<template>
  <div class="download-more-page">
    <headerTop />
    <div class="download-more-container">
      <div class="download-app">
        <h1>{{$t('300248')}}</h1>
        <p>{{$t('300249')}}</p>
        <div class="flex-between">
          <div class="qrcode-box">
            <div id="qrcode"></div>
            <p v-html="$t('300253')"></p>
          </div>
          <div class="link-box">
            <div class="flex-between">
              <div class="flex" @click="goLink(downloadUrl.appStore)">
                <i class="iconfont icon-ios1"></i>
                <span class="block">App Store</span>
              </div>
              <div class="flex" @click="goLink(downloadUrl.TFLink)">
                <i class="iconfont icon-ios1"></i>
                <span class="block">TestFlight</span>
              </div>
            </div>
            <div class="flex-between">
              <div class="flex" @click="goLink(downloadUrl.googlePlay)">
                <i class="iconfont icon-guge2"></i>
                <span class="block">Google Play</span>
              </div>
              <div class="flex" @click="goLink(downloadUrl.androidApk)">
                <i class="iconfont icon-anzhuo3"></i>
                <span class="block">Android APK</span>
              </div>
            </div>
          </div>
        </div>
        <img src="../../static/images/img1.png" alt="">
      </div>
      <div class="download-auth">
        <h1>{{$t('300254')}}</h1>
        <p>{{$t('300255')}}</p>
        <div class="select-box">
          <!--SuperEx验证器-->
          <div class="select-item relative pointer">
            <div class="flex-between" @click="show1 = !show1;show2 = false;show3 = false">{{$t('300256')}} <i class="iconfont" :class="show1 ? 'icon-shangla' : 'icon-xiala'"></i></div>
            <div class="dropdown-box absolute" v-show="show1">
              <a href="https://apps.apple.com/us/app/superex-authenticator/id6443871151" class="block flex-center" target="_blank">
                <i class="iconfont icon-ios1"></i>&nbsp;<em class="normal inline-block">{{$t('300259')}}</em>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.superex.auth" class="block flex-center" target="_blank">
                <i class="iconfont icon-anzhuo3"></i>&nbsp;<em class="normal inline-block">{{$t('300260')}}</em>
              </a>
            </div>
          </div>
          <!--谷歌验证器-->
          <div class="select-item relative pointer">
            <div class="flex-between" @click="show2 = !show2;show1 = false;show3 = false">{{$t('300257')}} <i class="iconfont" :class="show2 ? 'icon-shangla' : 'icon-xiala'"></i></div>
            <div class="dropdown-box absolute" v-show="show2">
              <a href="https://apps.apple.com/us/app/google-authenticator/id388497605" class="block flex-center" target="_blank">
                <i class="iconfont icon-ios1"></i>&nbsp;<em class="normal inline-block">{{$t('300259')}}</em>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" class="block flex-center" target="_blank">
                <i class="iconfont icon-anzhuo3"></i>&nbsp;<em class="normal inline-block">{{$t('300260')}}</em>
              </a>
            </div>
          </div>
          <!--微软验证器-->
          <div class="select-item relative pointer">
            <div class="flex-between" @click="show3 = !show3;show2 = false;show1 = false">{{$t('300258')}} <i class="iconfont" :class="show3 ? 'icon-shangla' : 'icon-xiala'"></i></div>
            <div class="dropdown-box absolute" v-show="show3">
              <a href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458" class="block flex-center" target="_blank">
                <i class="iconfont icon-ios1"></i>&nbsp;<em class="normal inline-block">{{$t('300259')}}</em></a>
              <a href="https://play.google.com/store/apps/details?id=com.azure.authenticator" class="block flex-center" target="_blank">
                <i class="iconfont icon-anzhuo3"></i>&nbsp;<em class="normal inline-block">{{$t('300260')}}</em></a>
            </div>
          </div>
        </div>
        <img src="../../static/images/img2.png" alt="">
      </div>
    </div>
    <footerView />
  </div>
</template>

<script>

import "@/assets/newCss/reset.scss";
import "@/assets/tailwendcss.css";
import "@/assets/uemo-icon-font/fonts/ueicon.css";
import "@/assets/newCss/var.scss";
import "@/assets/newCss/base.scss";

import headerTop from "../compontents/headerTop";
import footerView from "../compontents/footerView";
import {versionsApi} from "@/api/resource";
import {mapGetters} from "vuex";
import QRcode from "qrcodejs2";
import {getDomains} from "../api/user";
import { languageArr, languageName } from '@/utils/utilsType'
import { setCookie,getCookie } from '@/utils/auth'
export default {
  name: "downloadMore",
  components: {
    headerTop,
    footerView
  },
  data() {
    return {
      domain: '',
      downloadUrl: {
        appStore: "",
        googlePlay: "",
        androidApk: "",
        TFLink: ""
      },
      show1: false,
      show2: false,
      show3: false
    }
  },
  computed: {
    ...mapGetters(['isDirection','language'])
  },
  created() {
    this.change_language()
    window.document.documentElement.setAttribute("dir", this.IsShow() ? 'rtl' : 'ltr');
    this.getDomains()
    this.getVersionsApi()
  },
  methods: {
    change_language(){
        let paramsName = this.$route.query.language
        const language = getCookie('language')||'en'
        if(paramsName!=language){
            if(languageArr.indexOf(paramsName)!==-1){
                setCookie('language',paramsName)
                this.$store.dispatch('setLanguageName',languageName[paramsName])
                setCookie('languageName', languageName[paramsName])
                document.documentElement.setAttribute('lang', paramsName)
                setTimeout(() => {
                    this.$i18n.locale = paramsName
                }, 500)
                this.$router.replace(`/downloadMore?language=${paramsName}`)
            }else{
                this.$router.replace(`/downloadMore?language=${language}`)
            }
        }
    },
    qrcode() {
      var _this = this;
      let qrcode = new QRcode("qrcode", {
        width: 112,
        height: 112, // 高度
        text: _this.domain + "/download", // 二维码内容
        correctLevel: QRcode.CorrectLevel.L
      });
      qrcode._el.title = ""; //清除标题，不然鼠标停留在二维码上面会暴露二维码内容
    },
    getDomains() {
      getDomains().then(res => {
        this.domain = res.data;
        this.qrcode();
      });
    },
    goLink(url) {
      if (!url) {
        return false
      }else {
        window.open(url)
      }
    },
    getVersionsApi() {
      versionsApi().then(res => {
        // this.downloadUrl.appStore = 'https://testflight.apple.com/join/nPtPpKJr'
        this.downloadUrl.TFLink = res.data.find(v => v.client == "2")
          ? res.data.find(v => v.client == "2").extraLink
          : "";
        this.downloadUrl.appStore = res.data.find(v => v.client == "2")
          ? res.data.find(v => v.client == "2").link
          : "";
        this.downloadUrl.googlePlay = res.data.find(v => v.client == "3")
          ? res.data.find(v => v.client == "3").link
          : "";
        this.downloadUrl.androidApk = res.data.find(v => v.client == "3")
          ? res.data.find(v => v.client == "3").extraLink
          : "";
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/uemo-scss/scss/abstracts/_mixins.scss';
@import '@/assets/uemo-scss/scss/abstracts/_functions.scss';

@import "../style/mixin";
@import "../assets/css/variableName";
.download-more-page{
  background-color: #ffffff;
  padding-top: torem(50);
  .download-more-container{
    //background: #FFFFFF;
    padding: torem(24) torem(16);
    .download-app{
      h1{
        margin: 0 0 torem(16);
        color: #000922;
        font-size: torem(20);
        font-weight: bold;
      }
      p{
        color: #40475A;
        font-size: torem(14);
        line-height: torem(21);
        margin-bottom: torem(32);
      }
      .qrcode-box{
        width: torem(146);
        height: torem(192);
        padding: torem(16) torem(17) 0;
        border-radius: torem(4);
        box-shadow: 0 torem(2) torem(4) 0 rgba(0, 0, 0, 0.08);
        text-align: center;
        #qrcode{
          border-radius: torem(4);
        }
        p {
          margin-top: torem(7);
          line-height: torem(14);
          font-size: torem(12);
          color: #000922;
        }
      }
      .link-box{
        width: torem(177);
        div.flex-between{
          div.flex{
            width: torem(80);
            height: torem(78);
            margin-bottom: torem(16);
            flex-direction: column;
            align-items: center;
            justify-content: center;
            i{
              font-size: torem(24);
              margin-bottom: torem(8);
              color: #333;
            }
            span{
              font-size: torem(12);
              color: #000922;
            }
          }
        }
      }
      img{
        width: torem(343);
        height: torem(242);
        margin: torem(24) 0 torem(48);
      }
    }
    .download-auth{
      h1{
        margin: 0 0 torem(16);
        color: #000922;
        font-size: torem(20);
        font-weight: bold;
      }
      p{
        color: #40475A;
        font-size: torem(14);
        line-height: torem(21);
        margin-bottom: torem(32);
      }
      .select-box{
        margin-top: torem(16);
        .select-item{
          width: 100%;
          margin-bottom: torem(12);
          div.flex-between{
            width: 100%;
            padding: torem(12) torem(16);
            color: #333333;
            font-size: torem(14);
            background-color: #F8F8F8;
            border-radius: torem(4);
            i{
              font-size: torem(12);
            }
          }
          .dropdown-box{
            background-color: #fff;
            border: torem(1) solid #EFEFEF;
            min-height: torem(120);
            height: auto;
            width: 100%;
            box-shadow: 0 torem(2) torem(4) 0 rgba(0,0,0,0.08);
            z-index: 9;
            padding: torem(16);
            border-radius: torem(4);
            a{
              color: #000922;
              font-size: torem(12);
              padding: torem(15) 0;
              em{
                line-height: 1;
              }
              &:first-child{
                border-bottom: torem(1) solid #EFEFEF;
              }
            }
          }
        }
      }
      img{
        width: torem(343);
        height: torem(270);
        margin: torem(32) 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/downloadMore.vue